angular.module('app').component('downloadXml', {
    bindings: {
        traceSummaryRequest: '<'
    },
    controllerAs: 'vm',
    controller: function (DownloadXmlExService) {
        let vm = this;
        vm.downloadXmlEx = downloadXmlEx;
        vm.downloadXml = downloadXml;
        vm.downloadZipEx = downloadZipEx;
        vm.downloadZip = downloadZip;
        let traceSummaryRequest;
        this.$onInit = function () {
            traceSummaryRequest = this.traceSummaryRequest;
        };
        this.$onChanges = function (changes) {
            if (changes.traceSummaryRequest) {
                traceSummaryRequest = this.traceSummaryRequest;
            }
        };
        function downloadXml(previous24Hours) {
            traceSummaryRequest.Previous24Hours = previous24Hours;
            DownloadXmlExService.downloadXml(traceSummaryRequest);
            reset();
        }
        // BH - Extended method for specific hours (didnt want to change the existing method)
        function downloadXmlEx(previousHoursNumber) {
            if (!angular.isUndefined(previousHoursNumber) &&
                previousHoursNumber > 0) {
                traceSummaryRequest.PreviousHoursNumber = previousHoursNumber;
                traceSummaryRequest.PreviousHours = true;
                DownloadXmlExService.downloadXml(traceSummaryRequest);
            }
            reset();
        }
        function downloadZip(previous24Hours) {
            traceSummaryRequest.Previous24Hours = previous24Hours;
            DownloadXmlExService.downloadZip(traceSummaryRequest);
            reset();
        }
        // BH - Extended method for specific hours (didnt want to change the existing method
        function downloadZipEx(previousHoursNumber) {
            if (!angular.isUndefined(previousHoursNumber) &&
                previousHoursNumber > 0) {
                traceSummaryRequest.PreviousHoursNumber = previousHoursNumber;
                traceSummaryRequest.PreviousHours = true;
                DownloadXmlExService.downloadZip(traceSummaryRequest);
            }
            reset();
        }
        function reset() {
            traceSummaryRequest.PreviousHoursNumber = 0;
            traceSummaryRequest.PreviousHours = false;
            traceSummaryRequest.Previous24Hours = false;
        }
    },
    template: `
<!-- Download Trace XML-->
<!-- Used by UtpTraceSummary and Attachments??? Is it??? -->
<span class="text-mono" uib-dropdown>
             <button type="button" class="btn btn-info btn-sm" uib-dropdown-toggle>
            <span class="space-right">Trace XML</span><span class="caret"></span>
</button>
<ul uib-dropdown-menu role="menu" class="dropdown-menu-right">
      <li class="dropdown-header">Download XML</li>
      <li class="pointer" role="menuitem">
            <!-- Could have generated dynamically but decided to just specify some random hours -->
            <a ng-href="" ng-click="vm.downloadXmlEx(1)">
                  <i class="glyphicon glyphicon-file space-right"></i> Previous 1 Hour
            </a>
            <a ng-href="" ng-click="vm.downloadXmlEx(2)">
                  <i class="glyphicon glyphicon-file space-right"></i> Previous 2 Hours
            </a>
            <a ng-href="" ng-click="vm.downloadXmlEx(5)">
                  <i class="glyphicon glyphicon-file space-right"></i> Previous 5 Hours
            </a>
            <a ng-href="" ng-click="vm.downloadXmlEx(12)">
                  <i class="glyphicon glyphicon-file space-right"></i> Previous 12 Hours
            </a>
            <a ng-href="" ng-click="vm.downloadXmlEx(24)">
                  <i class="glyphicon glyphicon-file space-right"></i> Previous 24 Hours
            </a>
      </li>
      <li class="pointer" role="menuitem">
            <a ng-href="" ng-click="vm.downloadXml(false)">
                  <i class="glyphicon glyphicon-file space-right"></i> All traces (max 1000)
            </a>
      </li>
      <li role="separator" class="divider"></li>
      <li class="dropdown-header">Download ZIP</li>
      <li class="pointer" role="menuitem">
            <!-- Could have generated dynamically but decided to just specify some random hours -->
            <a ng-href="" ng-click="vm.downloadZipEx(1)">
                  <i class="glyphicon glyphicon-compressed space-right"></i> Previous 1 Hour
            </a>
            <a ng-href="" ng-click="vm.downloadZipEx(2)">
                  <i class="glyphicon glyphicon-compressed space-right"></i> Previous 2 Hours
            </a>
            <a ng-href="" ng-click="vm.downloadZipEx(5)">
                  <i class="glyphicon glyphicon-compressed space-right"></i> Previous 5 Hours
            </a>
            <a ng-href="" ng-click="vm.downloadZipEx(12)">
                  <i class="glyphicon glyphicon-compressed space-right"></i> Previous 12 Hours
            </a>
            <a ng-href="" ng-click="vm.downloadZipEx(24)">
                  <i class="glyphicon glyphicon-compressed space-right"></i> Previous 24 Hours
            </a>
      </li>
      <li class="pointer" role="menuitem">
            <a ng-href="" ng-click="vm.downloadZip(false)">
                  <i class="glyphicon glyphicon-compressed space-right"></i> All traces (max 1000)
            </a>
      </li>
</ul>
</span>
    `
});
